import type { SupportedIdDocType } from '@/idv2/features/collect-document/types';
import { DOC_REQUEST_KIND } from '@/idv2/features/collect-document/types';
import type { NonIdDocKinds } from '../types';

const requestKindToDocType: Record<NonIdDocKinds, SupportedIdDocType> = {
  [DOC_REQUEST_KIND.proofOfAddress]: 'proof_of_address',
  [DOC_REQUEST_KIND.proofOfSsn]: 'ssn_card',
  [DOC_REQUEST_KIND.custom]: 'custom',
};

export default requestKindToDocType;
